var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4425 16.5L11.25 12.3075V5.25H12.75V11.685L16.5 15.4425L15.4425 16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C10.6012 1.5002 9.21669 1.78108 7.92842 2.32602C6.64015 2.87096 5.47433 3.66887 4.5 4.6725V1.5H3V7.5H9V6H5.31C6.71702 4.43647 8.62724 3.41515 10.7089 3.1134C12.7905 2.81166 14.9121 3.24856 16.7052 4.34823C18.4983 5.4479 19.8495 7.14086 20.5243 9.1331C21.1991 11.1253 21.1547 13.291 20.399 15.2539C19.6433 17.2169 18.2239 18.8531 16.3873 19.8785C14.5507 20.9039 12.4131 21.2536 10.3455 20.8669C8.27793 20.4803 6.41111 19.3816 5.06925 17.7618C3.72739 16.142 2.99525 14.1034 3 12H1.5C1.5 14.0767 2.11581 16.1068 3.26957 17.8335C4.42332 19.5602 6.0632 20.906 7.98182 21.7007C9.90045 22.4955 12.0116 22.7034 14.0484 22.2982C16.0852 21.8931 17.9562 20.8931 19.4246 19.4246C20.8931 17.9562 21.8931 16.0852 22.2982 14.0484C22.7034 12.0116 22.4955 9.90045 21.7007 7.98182C20.906 6.0632 19.5602 4.42332 17.8335 3.26957C16.1068 2.11581 14.0767 1.5 12 1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHistory);
export default __webpack_public_path__ + "static/media/ic-history.448e2552ef6016b53ada838cad118752.svg";
export { ForwardRef as ReactComponent };